import {imprintsService} from './imprints';
import {artistsService} from './artists';
import {productsService} from './products';

export const artworkService = {
    uploadArtwork
};

const uploaders = {
    imprints: imprintsService.uploadArtwork,
    artists: artistsService.uploadArtwork,
    products: productsService.uploadArtwork
};

function uploadArtwork(entity, id, body) {
    const uploader = uploaders[entity];
    if(!uploader)
        return Promise.reject(new Error('image upload failed'));
    return uploader(id, body).then(data => {
        if(data && data.data && data.data.message)
            return data.data.message;
        return data;
    }, () => {
        throw new Error('image upload failed');
    });
}
